if (!customElements.get('atos-product')) {
  customElements.define('atos-product', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      const buttons = [...this.querySelectorAll('.ap-thumbs button')];
      const photos = [...this.querySelectorAll('.ap-photo')];
      buttons.forEach(button => button.addEventListener('click', () => {
        photos.forEach(photo => { photo.hidden = photo.id !== button.getAttribute('aria-controls'); });
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal }));
      const hero = this.querySelector('.ap-hero');
      const bar = this.querySelector('.ap-quote-bar');
      this.observer = new IntersectionObserver(([entry]) => { bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0); }, { threshold: 0 });
      this.observer.observe(hero);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
